import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux'
import '../config.js';
import { createFormData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';

function EnquiryForm(props) {
  const type = props.type;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('None');
  const [mobile, setMobile] = useState('');
  const [remark, setRemark] = useState('');
  const [code, setCode] = useState('');
  const [success, setSuccess] = useState(false);
  const myEnquiryForm = useRef();
  const packageId = useSelector(state => state.enquiry.package);

  const handleSubmit = (e) => {
    e.preventDefault();
    let packageLink = 'None';
    if(props.packageId){
      packageLink = global.config.public_server + '/package/' + props.packageId
    }else if(packageId != 'none'){
      packageLink = global.config.public_server + '/package/' + packageId
    }
    if(name && email && country != "None" && mobile && remark){
      axios.post(global.config.api_server+'enquiry',createFormData({
        name: name,
        email: email,
        country: country,
        mobile: code + " - " + mobile,
        remark: remark,
        packageLink:packageLink
      })).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          myEnquiryForm.current.reset();
          if(type === "sidebar"){
            const enquiryButton = document.getElementById('enquiry-msg-btn-js');
            enquiryButton.click();
          }else{
            setSuccess(true);
          }
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
      });
    }else{
      alertService.error('All the fields are required');
    }
  }
  
  const countryCodes = global.config.country_code;

  let classVariant = "col-md-6";
  if(type === "sidebar"){
    classVariant = "col-md-12";
  }

  const updateCode = (v) => {
    countryCodes.forEach(c => {
      if(c.country === v){
        setCode(c.code);
        return;
      }
    });
  }

  if(success){
    return( 
      <div className="row">
        <div className="col-md-12">
          <p>Thank you very much for contacting us. We have noted your details and one of our tour specialists will contact you very soon!</p>
          <button className={'btn btn-primary float-end'} type="reset" data-dismiss="modal" onClick={(e) => setSuccess(false)}>Close</button>
        </div>
      </div>
    )
  }else{
   return(
    <form ref={myEnquiryForm}>
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
            <input type="text" maxLength="100" required name="name" className="form-control" id="name" placeholder="Name *" onChange={(e) => setName(e.target.value)}/>
          </div>
        </div>
        <div className="col-md-12">
          <div className="mb-3">
            <input type="email" maxLength="100" required name="email" className="form-control" id="email" placeholder="Email *" onChange={(e) => setEmail(e.target.value)}/>
          </div>
        </div>
        <div className={classVariant}>
          <div className="mb-3">
            <select maxLength="50" name="country" required className="form-control" id="country" onChange={(e) => {setCountry(e.target.value);updateCode(e.target.value)}}>
              <option value="None">Your Country *</option>
              {countryCodes.map((c)=>
                <option key={c.iso} value={c.country}>{c.country}</option>
              )}
            </select>
          </div>
        </div>
        <div className={classVariant}>
          <div className="mb-3 input-group">
          <div className="input-group-prepend">
            <span className="input-group-text" id="isd-code">+{code}</span>
          </div>
            <input type="text" maxLength="20" required name="mobile" className="form-control" id="mobile" placeholder="Contact No. *" onChange={(e) => setMobile(e.target.value)}/>
          </div>
        </div>
        <div className="col-md-12">
          <div className="mb-3">
            <textarea maxLength="500" name="remark" required className="form-control" id="remark" placeholder="Tell us more..." onChange={(e) => setRemark(e.target.value)}></textarea>
          </div>
        </div>
        <hr/>
        <div className="col-md-12">
          <button className="btn btn-default float-end" type="reset" data-dismiss="modal">Close</button>
          <button className={'btn btn-primary float-end'} type="button" onClick={(e) => handleSubmit(e)}>Submit</button>
          {type === "sidebar" &&
            <a href="#" className="no-display" id="enquiry-msg-btn-js" data-toggle="modal" data-target="#enquiryMsgModal" data-bs-toggle="modal" data-bs-target="#enquiryMsgModal"> Success</a>
          }
        </div>
      </div>
    </form>
    )
  }
}

export default EnquiryForm;